<template>
  <div class="CalculatorBody">
    <div class="dontPrint">
      <v-container id="patientInfo">
        <v-row>
          <v-col cols="12" lg="6">
            <!-- patient info -->
            <calculatorPatientInfo
              id="calculatorPatientInfo"
              :name.sync="patientName"
              :inputBirthDate.sync="inputBirthDate"
              :idNumber.sync="patientIdName"
              :gender.sync="patientGender"
              :pickedDate.sync="pickedDate"
              :pickedBirthDate.sync="pickedBirthDate"
              :inputDate.sync="inputDate"
              :validate.sync="validatePatientInfo"
              :clear-form.sync="clearPatientInfo"
              @submit="onPatientFormValid"
            />
          </v-col>
          <!-- ad -->
          <v-col cols="12" lg="6">
            <ad id="ad" />
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-container id="printPDF">
      <h2>{{ $t("report_title") }}</h2>
      <p>{{ $t("report_text") }}</p>
      <h2>{{ $t("patient_info_title") }}</h2>
      <v-row row>
        <v-col lg4>
          <p>
            <label>
              {{ $t("patient_identificator") }}:
              {{ patientName }}
            </label>
          </p>
        </v-col>
        <v-col lg4>
          <p>
            <label>
              {{ $t("birth_date") }}:
              {{ inputBirthDate }}
            </label>
          </p>
        </v-col>
        <v-col lg4>
          <p>
            <label>
              {{ $t("result_date") }}:
              {{ inputDate }}
            </label>
          </p>
        </v-col>
      </v-row>
    </v-container>
    <!-- human body -->
    <v-container>
      <calculatorHumanBody
        id="calculatorHumanBody"
        :clear-form="clearBodyInfo"
        :loading="loading"
        :validate.sync="validateHumanBody"
        :multiplier="multiplier"
        @save-patient-click="validatePatientInfo = true"
        @patient-body="onSavePatient"
        @generate-report="onGenerateReport"
      />
    </v-container>
    <v-dialog v-model="showDialog" persistent max-width="500">
      <v-card>
        <v-card-title> {{ $t("patient_create") }}</v-card-title>
        <v-card-text>
          <p>
            Pacient byl přidán do databáze Vašich pacientů. Pro zobrazení
            databáze klikněte na
            <span class="link" @click="$router.push({ name: 'pacienti' })"
              >Moji pacienti</span
            >.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#324c8d" text @click="onAddNewPatient">{{
            $t("patient_add")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import goTo from "vuetify/es5/services/goto";
import moment from "moment";

import calculatorPatientInfo from "@/components/Calculator_patient_info.vue";
import calculatorHumanBody from "@/components/Calculator_human_body.vue";
import ad from "@/components/Ad.vue";
import tokenMixin from "@/mixins/tokenMixin.js";

export default {
  components: {
    calculatorPatientInfo,
    calculatorHumanBody,
    ad
  },
  mixins: [tokenMixin],
  data() {
    return {
      drawer: null,
      patientName: "",
      patientIdName: "",
      patientGender: "Žena",
      myFormatedDate: "",
      patientBirthDate: "",
      inputDate: "",
      inputBirthDate: "",
      pickedDate: "",
      pickedBirthDate: "",
      language: "Čeština",
      czech: null,
      validatePatientInfo: false,
      loading: false,
      showDialog: false,
      clearPatientInfo: false,
      clearBodyInfo: false,
      validateHumanBody: false,
      patient: null,
      multiplier: [0.1, 0.2, 0.3, 0.4]
    };
  },
  watch: {
    pickedDate: function() {
      let myDate = new Date(this.pickedDate);
      let myYear = myDate.getFullYear();
      let myMonth = myDate.getMonth() + 1;
      let myDay = myDate.getDate();
      this.myFormatedDate = myDay + ". " + myMonth + ". " + myYear;
      this.inputDate = this.myFormatedDate;
    },
    pickedBirthDate: function() {
      let myDate = new Date(this.pickedBirthDate);
      let myYear = myDate.getFullYear();
      let myMonth = myDate.getMonth() + 1;
      let myDay = myDate.getDate();
      this.myFormatedDate = myDay + ". " + myMonth + ". " + myYear;
      this.inputBirthDate = this.myFormatedDate;

      const birthDate = moment(this.inputBirthDate, '"DD-MM-YYYY"');
      const age = moment().diff(birthDate, "years", false);
      if (age <= 7) {
        this.multiplier = [0.2, 0.2, 0.3, 0.3];
      } else {
        this.multiplier = [0.1, 0.2, 0.3, 0.4];
      }
    },
    inputBirthDate() {
      const birthDate = moment(this.inputBirthDate, '"DD-MM-YYYY"');
      const age = moment().diff(birthDate, "years", false);
      if (age <= 7) {
        this.multiplier = [0.2, 0.2, 0.3, 0.3];
      } else {
        this.multiplier = [0.1, 0.2, 0.3, 0.4];
      }
    }
  },
  methods: {
    clickToScroll(el, pos) {
      let element = document.querySelector(el);
      element.scrollIntoView({
        behavior: "smooth",
        block: pos,
        inline: "nearest"
      });
      document.getElementById(el).scrollTop += 100;
    },
    onLocaleChange() {
      this.$i18n.locale = this.$i18n.locale === "cs" ? "sk" : "cs";
      this.language = this.czech === true ? "Čeština" : "Slovenština";
    },
    onAddNewPatient() {
      this.showDialog = false;
      this.clearPatientInfo = true;
      this.clearBodyInfo = true;
      goTo(0);
    },
    onGenerateReport() {
      // In case cordova use appropriate plugin
      if (process.env.BASE_URL === "") {
        this.$store.commit("setPrintPage", true);
        // Set default pdf name
        window.cordova.plugins.printer.setDefaults({
          name: "EASI-score-report",
          orientation: "landscape",
          pageCount: 1
        });
        window.cordova.plugins.printer.print();
        setTimeout(() => {
          this.$store.commit("setPrintPage", false);
        }, 2000);
      } else {
        window.print();
      }
    },
    onPatientFormValid(event) {
      this.validateHumanBody = true;
      this.patient = event;
    },
    async onSavePatient(event) {
      try {
        this.loading = true;
        await this.$_checkTokenExpiration();
        const {
          body: { patient }
        } = await this.$http.post("patients", { patient: this.patient });
        await this.$http.post(`patients/${patient.id}/form`, {
          form: {
            body_parts: event,
            evaluated_on: this.patient.evaluated_on
          }
        });
        this.showDialog = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#patientInfo {
  margin: 0 auto 2em auto;
}
#ad {
  height: 100%;
}
#printPDF {
  display: none;
}

@media only screen and (min-width: 200px) and (max-width: 425px) {
  #patientInfo {
    margin: 0 auto 0em auto;
  }
  .container {
    padding-bottom: 0;
  }
}

.container {
  @media only screen and (min-width: 1264px) and (max-width: 1920px) {
    max-width: 1500px;
  }
}
.v-content {
  margin: 0 5em;
}

//Menu styles
.fas {
  margin-right: 1em;
  color: #324c8d;
}
.v-list-item__title.mennuHeader {
  padding: 5px 0;
  font-size: 1em;
  color: #324c8d;
}
.v-toolbar__title {
  a {
    color: white;
    text-decoration: none;
  }
}

.v-dialog {
  .v-card {
    background-color: #f5f5f5;
  }

  .v-card__text {
    background: white;
    padding-top: 1rem;
    font-size: 1rem;
  }

  .link {
    color: #415995;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
